import { GridColDef } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import { UserInterface, UserChangePasswordInterface } from '../../../interfaces/interfaces';

export const getUsersTableColumns = (
  setUserToDelete: (user: UserInterface) => void,
  setDeleteDialogOpen: (open: boolean) => void,
  setUserToDeactivate: (user: UserInterface) => void,
  setDeactivateDialogOpen: (open: boolean) => void,
  setUserToActivate: (user: UserInterface) => void,
  setActivateDialogOpen: (open: boolean) => void,
  setUserToUpdate: (user: UserInterface) => void,
  setUpdateDialogOpen: (open: boolean) => void,
  setUserToChangePassword: (user: UserChangePasswordInterface) => void,
  setChangePasswordDialogOpen: (open: boolean) => void
): GridColDef[] => [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'username', headerName: 'Username', width: 130 },
  { field: 'name', headerName: 'Name', width: 180 },
  { field: 'email', headerName: 'Email', width: 200 },
  { field: 'phone', headerName: 'Phone', width: 130 },
  { field: 'address', headerName: 'Address', width: 180 },
  { field: 'userRoleId', headerName: 'Role', width: 80 },
  { field: 'active', headerName: 'Active', width: 80, type: 'boolean' },
  { field: 'created_at', headerName: 'Created', width: 180 },
  { field: 'updated_at', headerName: 'Updated', width: 180 },
  {
    field: 'delete',
    headerName: 'Delete',
    width: 100,
    renderCell: (params) => (
      <Button
        color="error"
        variant="outlined"
        size="small"
        onClick={() => {
          setUserToDelete(params.row);
          setDeleteDialogOpen(true);
        }}
      >
        Delete
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'toggleActive',
    headerName: 'Activate/Deactivate',
    width: 150,
    renderCell: (params) => (
      <Button
        color={params.row.active ? 'warning' : 'success'}
        variant="outlined"
        size="small"
        onClick={() => {
          if (params.row.active) {
            setUserToDeactivate(params.row);
            setDeactivateDialogOpen(true);
          } else {
            setUserToActivate(params.row);
            setActivateDialogOpen(true);
          }
        }}
      >
        {params.row.active ? 'Deactivate' : 'Activate'}
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
  {
    field: 'update',
    headerName: 'Update',
    width: 100,
    renderCell: (params) => (
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={() => {
          setUserToUpdate(params.row);
          setUpdateDialogOpen(true);
        }}
      >
        Update
      </Button>
    ),
    sortable: false,
    filterable: false,
  },
{
  field: 'changePassword',
  headerName: 'Change Password',
  width: 150,
  renderCell: (params) => (
    <Button
      color="secondary"
      variant="outlined"
      size="small"
      onClick={() => {
        setUserToChangePassword({ userId: params.row.id, newPassword: '' });
        setChangePasswordDialogOpen(true);
      }}
    >
      Change Password
    </Button>
  ),
  sortable: false,
  filterable: false,
},  
];